window.Minus40Core = class Minus40Core {

    /** @type {Minus40Core} */
    static instance = null;

    static getInstance() {
        if(this.instance !== null) {
            return this.instance;
        }
        this.instance = new Minus40Core();
        return this.instance;
    }

    pageVars = {}
    embeddedJavascriptStates = {};

    constructor() {
        this.parsePageVars();
    }

    parsePageVars(){
        this.pageVars = typeof page_vars !== 'undefined' && page_vars ? page_vars : this.pageVars;
    }

    /**
     *
     * @param value {string}
     * @returns {string}
     */
    trimSlashes(value){
        return value.replace(/^\/+|\/+$/g, '');
    }

    /**
     *
     * @param object {{}}
     * @returns {number}
     */
    keyCount(object)
    {
        return Object.keys(object).length
    }

    /**
     *
     * @param value {any}
     * @param notEmpty {boolean=}
     * @returns {boolean}
     */
    isArray(value, notEmpty)
    {
        return !!value && Array.isArray(value) && (!notEmpty || !!value.length);
    }

    /**
     *
     * @param value {any}
     * @param notEmpty {boolean=}
     * @returns {boolean}
     */
    isObject(value, notEmpty)
    {
        return !!value && typeof value === 'object' && !this.isArray(value) && (!notEmpty || !!this.keyCount(value));
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isAnyNull(value)
    {
        return value === undefined || value === null;
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isNumber(value)
    {
        return !this.isAnyNull(value) && typeof value === 'number';
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isNumeric(value)
    {
        return !this.isAnyNull(value) && !isNaN(value) && value !== "";
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isString(value)
    {
        return !this.isAnyNull(value) && (typeof value === 'string' || value instanceof String)
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isBool(value)
    {
        return value === true || value === false;
    }

    /**
     *
     * @param value {string}
     * @returns {string}
     */
    numericString(value)
    {
        return value.replace(/[^\d.-]/g, '');
    }

    /**
     *
     * @param object {{}}
     * @returns {string|null}
     */
    firstKey (object)
    {
        const keys = Object.keys(object);
        return keys.length ? keys[0] : null;
    }

    /**
     *
     * @param text {string}
     * @returns {string}
     */
    stripHTML (text)
    {
        const div = document.createElement("div");
        div.innerHTML = text;
        return div.textContent || div.innerText || "";
    }

    /**
     *
     * @param string {string}
     * @returns {string}
     */
    ucWords(string){
        return string.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
    };

    /**
     *
     * @param value {any}
     * @returns {{}|[]|null}
     */
    validJSON(value) {
        try {
            const obj = value && (typeof value === 'string') ? JSON.parse(value) : null;
            if (obj && ((typeof obj === "object") || Array.isArray(obj))) {
                return obj;
            }
        } catch (e) {

        }
        return null;
    }

    /**
     *
     * @param string {string}
     * @returns {string}
     */
    alphaNumeric(string){
        return string.replace(/[^0-9A-Z]+/gi,"");
    }

    /**
     *
     * @param string1 {string}
     * @param string2 {string}
     * @returns {boolean}
     */
    compareSimilarStrings(string1, string2){
        return this.alphaNumeric(string1).toLowerCase() === this.alphaNumeric(string2).toLowerCase();
    }

    /**
     *
     * @param matchingString {string}
     * @param arrayGroup {{}}
     * @returns {string|null}
     */
    findKeyInArrayGroup(matchingString, arrayGroup){
        for(let key in arrayGroup){
            const array = arrayGroup[key];
            for(let item of array){
                if(this.compareSimilarStrings(item, matchingString)){
                    return key;
                }
            }
        }
        return null;
    }

    /**
     *
     * @param ms {number}
     * @returns {Promise<unknown>}
     */
    sleep(ms)
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /**
     *
     * @param string {string}
     * @returns {string}
     */
    capitalizeFirstLetter(string) {
        return String(string).charAt(0).toUpperCase() + String(string).slice(1);
    }

    /**
     *
     * @param string {string}
     * @returns {string}
     */
    toCamelCase(string)
    {
        const parts = string.split(/[-_]/);
        let returnString = "";
        for(let part of parts){
           if(!part){
               continue;
           }
           if(returnString){
               part = this.capitalizeFirstLetter(part);
           }
            returnString = returnString + part;
        }
        return returnString;
    }

    /**
     *
     * @param number {number}
     * @param min {number}
     * @param max {number}
     * @returns {number}
     */
    clamp(number, min, max) {
        return Math.max(min, Math.min(number, max));
    }

    /**
     *
     * @param key {string}
     * @param value {string|number=}
     */
    updateQueryStringParam(key, value) {
        value = value ?? "";
        const url = new URL(window.location);
        if(value !== ""){
            url.searchParams.set(key, value); // add or update the parameter
        } else {
            url.searchParams.delete(key)
        }
        window.history.replaceState({}, '', url); // update the address bar without reload
    }

    /**
     *
     * @param timestamp {string}
     */
    timestampToDate(timestamp) {
        const arr = timestamp.split(/[-\s:]/);// split string and create array.
        return new Date(parseInt(arr[0]), parseInt(arr[1]) -1, parseInt(arr[2]), parseInt(arr[3]), parseInt(arr[4]), parseInt(arr[5])); // decrease month value by 1
    }



    /**
     *
     * @param location {string}
     * @param key {string}
     * @param value {string|number=}
     * @returns {string}
     */
    updateDefinedQueryStringParam(location, key, value) {
        value = value ?? "";
        const url = new URL(location);
        if(value !== ""){
            url.searchParams.set(key, value); // add or update the parameter
        } else {
            url.searchParams.delete(key)
        }
        return url.href;
    }

    /**
     *
     * @param string {string}
     */
    stripSpace(string){
        return string.replace(/\s+/g,' ').trim();
    }

    /**
     *
     * @param miles {number}
     * @returns {number}
     */
    milesToKilometres(miles)
    {
        return miles * 1.60934;
    }

    /**
     *
     * @param kilometres {number}
     * @returns {number}
     */
    kilometresToMiles(kilometres)
    {
        return kilometres / 1.60934;
    }

    /**
     *
     * @param degrees {number}
     * @returns {number}
     */
    degreesToRadians(degrees)
    {
        // Multiply degrees by pi divided by 180 to convert to radians.
        return degrees * (Math.PI / 180);
    }

    /**
     *
     * @param lat1 {number}
     * @param lng1 {number}
     * @param lat2 {number}
     * @param lng2 {number}
     * @returns {number}
     */
    getDistanceInMetresBetween(lat1, lng1, lat2, lng2)
    {

        //1.60934
        const latRad1 = this.degreesToRadians(lat1);
        const lngRad1 = this.degreesToRadians(lng1);
        const latRad2 = this.degreesToRadians(lat2);
        const lngRad2 = this.degreesToRadians(lng2);

        return Math.round((6371 * 1000 * Math.acos( Math.cos( latRad2 ) * Math.cos( latRad1 ) * Math.cos( lngRad1 - lngRad2 ) + Math.sin( latRad2 ) * Math.sin( latRad1 ) )));
    }

    /**
     *
     * @param element {HTMLElement}
     * @param ms {(number|null)=}
     * @param callback {(() => void)|null=}
     * @returns {{kill: () => void, defaultDisplay: string}}
     */
    fadeIn( element, ms, callback )
    {
        let timer = 0;
        const handleCallback = () => {
            if(callback){
                callback();
            }
        }
        /**
         *
         * @param opacity {number=}
         */
        const kill = (opacity) => {
            if(!isNaN(opacity)){
                opacity = this.clamp(opacity,0, 1);
                element.style.opacity = opacity.toString();
                element.style.filter = "alpha(opacity="+opacity+")";
            }
            clearTimeout(timer);
        }
        const fadeProgress = {
            kill: kill,
            defaultDisplay: ""
        }

        const previousFadeProgress = element?.fadeProgress ?? null;
        const previousKill = previousFadeProgress?.kill;
        const previousDefaultDisplay = previousFadeProgress?.defaultDisplay ?? "";
        if(previousKill){
            previousKill();
        }


        if( element )
        {
            if((element.style.display === "none") || (element.style.visibility === "hidden")){
                element.style.opacity = "0";
                element.style.filter = "alpha(opacity=0)";
            }
            element.style.visibility = "visible";
            if(element.style.display === "none"){
                element.style.display = previousDefaultDisplay;
            }
            fadeProgress.defaultDisplay = element.style.display;
            element.fadeProgress = fadeProgress;
        }

        ms = Math.max(ms ?? 0, 0);

        if( ! ms )
        {
            if( element )
            {
                element.style.opacity = "1";
                element.style.filter = "alpha(opacity=1)";
            }
            handleCallback();
            return fadeProgress;
        }

        if( ! element )
        {
            timer = setInterval( ()=> {
                handleCallback();
            }, ms );

            return fadeProgress;
        }
        const steps = Math.ceil(ms / 50);
        let fromOpacity = parseFloat(element.style.opacity ?? "1");
        fromOpacity = this.clamp(!isNaN(fromOpacity) ? fromOpacity : 1, 0, 1);
        const inc = (1 - fromOpacity) / steps;
        timer = setInterval( ()=> {
            fromOpacity += inc;
            if( fromOpacity >= 1 )
            {
                clearInterval(timer);
                fromOpacity = 1;
            }
            element.style.opacity = fromOpacity;
            element.style.filter = "alpha(opacity=" + fromOpacity * 100 + ")";
            if(fromOpacity === 1){
                handleCallback();
            }
        }, Math.min(ms, 50) );
        return fadeProgress;
    }

    /**
     *
     * @param element {HTMLElement}
     * @param ms {(number|null)=}
     * @param keepDisplay {(boolean|null)=}
     * @param callback {(() => void)|null=}
     * @returns {{kill: () => void, defaultDisplay: string}}
     */
    fadeOut( element, ms, keepDisplay, callback )
    {
        let timer = 0;
        const handleCallback = () => {
            if(callback){
                callback();
            }
        }
        /**
         *
         * @param opacity {number=}
         */
        const kill = (opacity) => {
            if(!isNaN(opacity)){
                opacity = this.clamp(opacity,0, 1);
                element.style.opacity = opacity.toString();
                element.style.filter = "alpha(opacity="+opacity+")";
            }
            clearTimeout(timer);
        }
        const fadeProgress = {
            kill: kill,
            defaultDisplay: ""
        }

        const previousFadeProgress = element?.fadeProgress ?? null;
        const previousKill = previousFadeProgress?.kill;
        const previousDefaultDisplay = previousFadeProgress?.defaultDisplay ?? "";
        if(previousKill){
            previousKill();
        }


        if( element )
        {
            fadeProgress.defaultDisplay = element.style.display !== "none" ? element.style.display : previousDefaultDisplay;
            element.fadeProgress = fadeProgress;
        }

        ms = Math.max(ms ?? 0, 0);

        if( ! ms )
        {
            if( element )
            {
                element.style.opacity = "0";
                element.style.filter = "alpha(opacity=0)";
                element.style.display = "none";
                element.style.visibility = "hidden";
            }
            handleCallback();
            return fadeProgress;
        }

        if( ! element )
        {
            timer = setInterval( ()=> {
                handleCallback();
            }, ms );

            return fadeProgress;
        }

        const steps = Math.ceil(ms / 50);
        let fromOpacity = parseFloat(element.style.opacity ?? "1");
        fromOpacity = this.clamp(!isNaN(fromOpacity) ? fromOpacity : 1, 0, 1);
        const dec = fromOpacity / steps;

        timer = setInterval( ()=> {
            fromOpacity -= dec;
            if( fromOpacity <= 0 )
            {
                clearInterval(timer);
                fromOpacity = 0;
            }
            element.style.opacity = fromOpacity;
            element.style.filter = "alpha(opacity=" + fromOpacity * 100 + ")";
            if(fromOpacity === 0){
                if(!keepDisplay){
                    element.style.display = "none";
                }
                element.style.visibility = "hidden";
                handleCallback();
            }
        }, Math.min(ms, 50) );

        return fadeProgress;
    }

    /**
     *
     * @param src {string}
     * @param callback {(boolean) => void}
     */
    embedJavascript(src, callback){
        const state = this.embeddedJavascriptStates[src] ?? {requested: false, determined: false, success: false, callbacks: []};
        this.embeddedJavascriptStates[src] = state;
        if(state.determined){
            callback(!!state.success);
            return;
        }
        state.callbacks.push(callback);
        if(state.requested){
            return;
        }
        state.requested = true;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;

        const handleDetermined = () => {
            state.determined = true;
            for(let callback of state.callbacks){
                callback(state.success)
            }
            state.callbacks.length = 0;
        }

        script.onload = () => {
            state.success = true;
            handleDetermined();
        };
        script.onerror = () =>{
            state.success = false;
            handleDetermined();
        };
        document.body.appendChild(script);

    }

}